import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-amountdollhouse',
  templateUrl: './amountdollhouse.component.html',
  styleUrls: ['./amountdollhouse.component.scss']
})
export class AmountdollhouseComponent implements OnInit, OnChanges {
  @Input() processingFeePlan;
  @Input() taxPercentage;
  amountLoader = true;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
   if (changes && changes.processingFeePlan && changes.processingFeePlan.currentValue) {
    this.amountLoader = false;
   }
  }

  getTotalPrice() {
    // tslint:disable-next-line:radix
    return this.getSubTotalPrice() + this.getTaxAmount();
  }

  getSubTotalPrice() {
    return this.processingFeePlan.new_price;
  }

  getTaxAmount() {
    if (this.taxPercentage && this.taxPercentage > 0) {
      const subTotalPrice = this.getSubTotalPrice();
      const taxAmount = subTotalPrice * this.taxPercentage / 100;
      return Math.round(taxAmount);
    }
    return 0;
  }

}
